<div class="banners">
    <div class="title">
        <div class="tit">
            <h3>KOLLÉGÁK</h3>
        </div>
        <div class="add-icon">
            <mat-icon [ngStyle]="{ cursor: 'pointer' }" routerLink="/addcolleague">add_circle</mat-icon>
        </div>
    </div>
    <form [formGroup]="colleagueForm!" novalidate>
        <div class="array" formArrayName="items" *ngFor="let colleague of colleagues; let i = index">
            <div class="pro">
                <div [formGroupName]="i" class="name">
                    <input
                        [ngStyle]="{ width: '100%' }"
                        [(ngModel)]="colleague.name"
                        formControlName="name"
                        id="name"
                        class="form-control"
                        type="text"
                        required
                    />

                    <input
                        [ngStyle]="{ width: '100%' }"
                        [(ngModel)]="colleague.jobTitle"
                        formControlName="jobTitle"
                        id="jobTitle"
                        class="form-control"
                        type="text"
                        required
                    />
                    <div class="image">
                        <input
                            [ngStyle]="{ width: '100%' }"
                            id="fileCoversInput"
                            #fileCoversInput
                            class="form-control"
                            type="file"
                            required
                            (change)="onChange($event, colleague)"
                        />
                        <div class="delete">
                            <a href="{{ colleague.imageUrl }}" target="_blank">Jelenlegi fájl</a>
                        </div>
                    </div>
                </div>
                <div [ngStyle]="i % 2 === 0 ? { background: 'white' } : { background: '#efeff5' }" class="delete-icon">
                    <mat-icon [ngStyle]="{'cursor':'pointer'}" (click)="openDeleteColleaguePopup(colleague)">delete_forever</mat-icon>
                </div>
            </div>
        </div>
    </form>
    <div [ngStyle]="{ 'margin-top': '8px' }" class="field-container">
        <div [ngStyle]="{ 'justify-content': 'center', 'margin-top': '8px', 'margin-bottom': '8px' }" class="field">
            <div [ngStyle]="{ 'justify-content': 'center', width: '70%' }" class="data">
                <button
                    (click)="updateColleagues()"
                    [ngStyle]="{ background: '#efeff5', border: '1px solid #ccc', 'font-weight': 'bold', width: '100%' }"
                    [disabled]="!colleagueForm?.valid"
                >
                    KOLLÉGÁK MÓDOSÍTÁSA
                </button>
            </div>
        </div>
    </div>
</div>
